<template>
  <van-nav-bar
    v-bind="$attrs"
    :title="title"
    :left-arrow="leftArrow"
    :fixed="fixed"
    :placeholder="placeholder"
    :border="border"
    :style="navStyle"
    @click-left="handleClickLeft"
  >
    <template #left>
      <van-icon v-if="leftArrow" name="arrow-left" style="font-weight: bold;" size="24" :color="leftArrowColor ? leftArrowColor : '#000'"/>
    </template>
    <template v-if="$slots.title" #title>
      <slot name="title" />
    </template>
    <template v-if="$slots.right" #right>
      <slot name="right" />
    </template>
  </van-nav-bar>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { safeBack } from '@/utils/navigation';

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  leftArrow: {
    type: Boolean,
    default: true
  },
  fixed: {
    type: Boolean,
    default: true
  },
  placeholder: {
    type: Boolean,
    default: true
  },
  border: {
    type: Boolean,
    default: false
  },
  backgroundColor: {
    type: String,
    default: ''
  },
  textColor: {
    type: String,
    default: ''
  },
  autoBack: {
    type: Boolean,
    default: true
  },
  fallbackTo: {
    type: String,
    default: '/home/index'
  },
  leftArrowColor: {
    type: String,
    default: '#000'
  }
});

const emit = defineEmits(['click-left']);
const router = useRouter();
const navStyle = computed(() => {
  const style = {};
  if (props.backgroundColor) {
    style.background = props.backgroundColor;
    style['--van-nav-bar-background'] = props.backgroundColor;
  } else {
    style.background = '#f7f7f7';
    style['--van-nav-bar-background'] = '#f7f7f7';
  }
  if (props.textColor) {
    style['--van-nav-bar-title-text-color'] = props.textColor;
    style['--van-nav-bar-icon-color'] = props.textColor;
    style['--van-nav-bar-text-color'] = props.textColor;
  }
  return Object.keys(style).length ? style : undefined;
});

function handleClickLeft(event) {
  emit('click-left', event);
  if (!props.autoBack) {
    return;
  }
  safeBack(router, props.fallbackTo);
}
</script>